//getPollWithParamsReportFields
import axios from 'axios'
import Utils from '../../../common/utils';

export default {
  getReportPollWithParams: function (parameters) {
    return axios.get('/api/analytics/pollWithParams/report', {params: parameters});
  },
  exportReportPollWithParams: function(parameters) {
    return Utils.downloadFile('/api/analytics/pollWithParams/exportreport', "ReportPollWithParams.xlsx", parameters);
  },
  getPollWithParamsReportFields: function() {
    return axios.get('/api/analytics/pollWithParams/fields');
  },

  getReportRasWithParams: function (parameters) {
    return axios.get('/api/analytics/rasWithParams/report', {params: parameters});
  },
  exportReportRasWithParams: function(parameters) {
    return Utils.downloadFile('/api/analytics/rasWithParams/exportreport', "ReportRasWithParams.xlsx", parameters);
  },
  getRasWithParamsReportFields: function() {
    return axios.get('/api/analytics/rasWithParams/fields');
  }
}